import { withBemMod } from '@bem-react/core';
import { useComponentRegistry } from '@bem-react/di';
import React, { FC, ReactElement } from 'react';

import { cnParticipantsList, registryId } from '../ParticipantsList';
import { ParticipantsListProps, ParticipantTypeComponentProps } from '../ParticipantsList.interface';
import { WithTypeActive } from './ParticipantsList_type_active.interface';

export const withTypeActive = withBemMod<WithTypeActive, ParticipantsListProps>(
    cnParticipantsList(),
    { type: 'active' },
    (ParticipantsList): FC<WithTypeActive & ParticipantsListProps> => (
        (props: WithTypeActive & ParticipantsListProps): ReactElement => {
            const { Participant } = useComponentRegistry(registryId);
            const participantTypes = {
                room: (componentProps: ParticipantTypeComponentProps): ReactElement => {
                    const {
                        item,
                        onDelete,
                        onChangeSelectedMethod,
                        onToggleMicrophone,
                        onToggleCamera,
                        isDisabledChangeSelectedMethod,
                    } = componentProps;

                    return (
                        <Participant
                            methodSelect
                            type="room"
                            title={item.name}
                            value={item.method}
                            options={item.action}
                            delete
                            key={item.id}
                            onDelete={onDelete}
                            onChangeSelectedMethod={onChangeSelectedMethod}
                            changeSelectedDisabled={isDisabledChangeSelectedMethod}
                            controls
                            microphone={item.microphone}
                            camera={item.camera}
                            microphoneActive={item.microphone_active}
                            cameraActive={item.camera_active}
                            acting={item.acting}
                            onToggleMicrophone={onToggleMicrophone}
                            onToggleCamera={onToggleCamera}
                        />
                    );
                },
                person: (componentProps: ParticipantTypeComponentProps): ReactElement => {
                    const {
                        item,
                        onDelete,
                        onChangeSelectedMethod,
                        onToggleMicrophone,
                        onToggleCamera,
                        isDisabledChangeSelectedMethod,
                    } = componentProps;

                    return (
                        <Participant
                            methodSelect
                            type="person"
                            id={item.id}
                            title={item.name}
                            value={item.method}
                            options={item.action}
                            delete
                            key={item.id}
                            onDelete={onDelete}
                            onChangeSelectedMethod={onChangeSelectedMethod}
                            changeSelectedDisabled={isDisabledChangeSelectedMethod}
                            controls
                            microphone={item.microphone}
                            camera={item.camera}
                            microphoneActive={item.microphone_active}
                            cameraActive={item.camera_active}
                            acting={item.acting}
                            onToggleMicrophone={onToggleMicrophone}
                            onToggleCamera={onToggleCamera}
                        />
                    );
                },
                arbitrary: (componentProps: ParticipantTypeComponentProps): ReactElement => {
                    const {
                        item,
                        onDelete,
                        onChangeSelectedMethod,
                        onToggleMicrophone,
                        onToggleCamera,
                        isDisabledChangeSelectedMethod,
                    } = componentProps;

                    return (
                        <Participant
                            methodSelect
                            type="arbitrary"
                            title={item.id}
                            options={item.action}
                            value={item.method}
                            delete
                            key={item.id}
                            onDelete={onDelete}
                            onChangeSelectedMethod={onChangeSelectedMethod}
                            changeSelectedDisabled={isDisabledChangeSelectedMethod}
                            controls
                            microphone={item.microphone}
                            camera={item.camera}
                            microphoneActive={item.microphone_active}
                            cameraActive={item.camera_active}
                            acting={item.acting}
                            onToggleMicrophone={onToggleMicrophone}
                            onToggleCamera={onToggleCamera}
                        />
                    );
                },
                cms: (componentProps: ParticipantTypeComponentProps): ReactElement => {
                    const {
                        item,
                        onDelete,
                        onChangeSelectedMethod,
                        onToggleMicrophone,
                        onToggleCamera,
                        isDisabledChangeSelectedMethod,
                    } = componentProps;

                    return (
                        <Participant
                            methodSelect
                            type="cms"
                            name={item.name}
                            options={item.action}
                            value={item.method}
                            delete
                            key={item.name}
                            onDelete={onDelete}
                            onChangeSelectedMethod={onChangeSelectedMethod}
                            changeSelectedDisabled={isDisabledChangeSelectedMethod}
                            controls
                            microphone={item.microphone}
                            camera={item.camera}
                            microphoneActive={item.microphone_active}
                            cameraActive={item.camera_active}
                            acting={item.acting}
                            onToggleMicrophone={onToggleMicrophone}
                            onToggleCamera={onToggleCamera}
                        />
                    );
                },
            };

            return (
                <ParticipantsList {...props} participantTypeComponents={participantTypes} />
            );
        }
    ),
);

export default withTypeActive;
